import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import '@mdi/font/css/materialdesignicons.css'

Vue.use(Vuetify, {
  iconfont: 'md',
})

// Paleta de marca Templus (gestão de igrejas) — verde-petróleo/teal + acento dourado.
// Centralizada aqui para padronizar todas as telas. customProperties expõe as
// cores como variáveis CSS (ex.: var(--v-primary-base)) para uso em <style>.
export default new Vuetify({
  icons: {
    iconfont: 'md',
  },
  theme: {
    dark: false,
    options: { customProperties: true },
    themes: {
      light: {
        primary: '#00695C',     // verde-petróleo (marca)
        secondary: '#00253E',   // azul-escuro (seções escuras)
        accent: '#01B094',      // teal (destaques)
        success: '#2E9E78',
        info: '#15AAF4',
        warning: '#F9A825',
        error: '#EF5350',
      },
      dark: {
        primary: '#5BC1A3',     // teal mais claro p/ contraste no escuro
        secondary: '#0a2a3f',
        accent: '#01B094',
        success: '#3CB68C',
        info: '#15AAF4',
        warning: '#F9A825',
        error: '#EF5350',
      },
    },
  },
});
